// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const PayoutReport = lazy(
  () => import('pages/reports/payoutReport/payoutReport')
);
const PayoutReportRoute = (
  <Route path={routeName.payoutReport}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.DOWNLOAD_PAYOUT_REPORT}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <PayoutReport />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default PayoutReportRoute;
